<template>
    <div id="m-inbox" style="height: 100%">
        <v-card elevation="0">
            <v-card-actions class="ma-0 pa-0 mx-3">
                <v-tabs v-model="tab" class="no-transition">
                    <v-tab key="i-users-by-app-version" @click="updateActiveTab('i-users-by-app-version')">Users by app version
                        <v-icon size="20" style="margin-left: 8px">mdi-alert-rhombus-outline</v-icon>
                    </v-tab>
                    <v-tab key="i-users-by-package-id" @click="updateActiveTab('i-users-by-package-id')">Users by package Id
                        <v-icon size="20" style="margin-left: 8px">mdi-package-variant</v-icon>
                    </v-tab>
                </v-tabs>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0 mx-3 mt-2">
                <v-card width="100%" class="ma-0 pa-0" elevation="0">
                    <v-card-actions class="ma-0 pa-0">
                        <v-card width="100%" class="ma-0 pa-0" elevation="0">
                            <v-tabs-items class="mt-0" v-model="tab">
                                <v-tab-item
                                        transition="fade-transition"
                                        reverse-transition="fade-transition"
                                        key="i-users-by-app-version">
                                    <i-users-by-app-version ref="i-users-by-app-version"></i-users-by-app-version>
                                </v-tab-item>
                                <v-tab-item
                                        transition="fade-transition"
                                        reverse-transition="fade-transition"
                                        key="i-users-by-package-id">
                                    <i-users-by-package-id ref="i-users-by-package-id"></i-users-by-package-id>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-card>
                    </v-card-actions>
                </v-card>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import InfoStore from "@/modules/minfo/database/InfoStore";
import IUsersByAppVersion from "@/modules/minfo/views/i-users-by-app-version";
import IUsersByPackageId from "@/modules/minfo/views/i-users-by-package-id";

export default {
    components: {IUsersByPackageId, IUsersByAppVersion},
    data: () => ({
        tab: null,
    }),
    computed:{
    },
    methods: {
        updateActiveTab(id){
            let tab = this.$refs[id]
            if (tab != undefined){tab.reloadData()}
        },
    },
    beforeMount() {
        this.$store.registerModule("info-store", InfoStore);
        this.$store.dispatch("info-store/init")
            .then(() => {
                console.log("Loaded successfully. info-store");
            }).catch(() => {})
    },
    destroyed() {
        this.$store.unregisterModule("info-store")
        console.log("destroy root view info");
    }
}
</script>

<style scoped>
</style>